import { InjectionToken } from '@angular/core';

export interface AuthEndpoints {
  base: string;
  login: string;
  refresh: string;
  mfaStatus: string;
  logout: string;
}

export interface AccountEndpoints {
  base: string;
  activateUser: string;
  consumeMagicLink: string;
  validateTotpReset: string;
  completeActivation: string;
  completePasswordReset: string;
  completeTotpReset: string;
}

export interface AppEndpoints {
  auth: AuthEndpoints;
  account: AccountEndpoints;
  wallet: { base: string };
}

export interface AuthConfig {
  baseUrl: string;
  endpoints: AppEndpoints;
  tokenStorageKey?: string;
  loginRoute?: string;
  supportEmail: string;
  authHeaderAllowedList?: string[];
}

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('AUTH_CONFIG');
